export const fillInformation = (state, action)=>{ 
    //UseReducer -> um useState  porém com inumeras variaveis e funções, no caso esse para 
    //cadastro de produtos
    switch(action.type){
        case "quantidadeTotalSacola":
            return {
                ...state,
                quantidadeTotalSacola: action.value
            };
        case "valorTotalSacola":
            return {
                ...state,
                valorTotalSacola: action.value
            };
        case "produtoPagina":
            return {
                ...state,
                produtoPagina: action.value
            };
        case "produtoPaginaSelectedInfo":
            return {
                ...state,
                produtoPaginaSelectedInfo: action.value
            };
        case "produtosSacola":
            return {
                ...state,
                produtosSacola: action.value
            };
        case "telaAtual":
            return {
                ...state,
                telaAtual: action.value
            };
        case "produtos":
            return {
                ...state,
                produtos: action.value
            };
        case "cpfCnpj":
            return {
                ...state,
                cpfCnpj: action.value
            };
        case "clientData":
            return {
                ...state,
                clientData: action.value
            };
        case "pedidoFinalizado":
            return {
                ...state,
                pedidoFinalizado: action.value
            };
        case "revistas":
            return {
                ...state,
                revistas: action.value
            };
        case "revistaSelecionada":
            return {
                ...state,
                revistaSelecionada: action.value
            };
        case "categorias":
            return {
                ...state,
                categorias: action.value
            };
        case "categoriaSelecionada":
            return {
                ...state,
                categoriaSelecionada: action.value
            };
        default:
            return {
                ...state
            };
        }
}